export class Usuario {
    constructor() {
        this.usuario = '';
        this.senha = '';
    }

    usuario: string;
    senha: string;
}